// extracted by mini-css-extract-plugin
export default {"activeBadge":"_1vw-LxRVEGrtJ54OhWjJPR","inactiveBadge":"YbJU3rjIKiNBAIIU-PP6c","iconCheck":"_1E4BW-fN_5Ddm8krv7eLuZ"};